import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        areaId: localStorage.getItem('areaId') || 1,
        ticket: localStorage.getItem('ticket') || '',
    },
    mutations: {
        changAreaId (state, val) {
            localStorage.setItem('areaId', val)
            state.areaId = val
        },
        UPDATE_TICKET (state, ticket) {
            localStorage.setItem('ticket', ticket)
            state.ticket = ticket
        }
    }
})

export default store